import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addJobs, getJobs, removeJobs, updateJobs } from "./jobsFinderAPI";

const initialState = {
  jobs: [],
  isLoading: false,
  isError: false,
  error: "",
  editing: {},
  sortSearchFilter: [],
  jobTypeFilter: [],
  jobType: "",
};

export const fetchJobs = createAsyncThunk("jobsFinder/fetchJobs", async () => {
  const response = await getJobs();
  return response;
});

export const createJob = createAsyncThunk(
  "jobsFinder/createJob",
  async (data) => {
    const response = await addJobs(data);
    return response;
  }
);

export const editJob = createAsyncThunk(
  "jobsFinder/editJob",
  async ({ data, id }) => {
    const response = await updateJobs(data, id);
    return response;
  }
);

export const deleteJob = createAsyncThunk(
  "jobsFinder/deleteJob",
  async (id) => {
    const response = await removeJobs(id);
    return response;
  }
);

// Create slice
const jobsFinderSlice = createSlice({
  name: "jobsFinder",
  initialState,
  reducers: {
    filterByJobType: (state, action) => {
      let filteredJobsType = state.jobs;
      switch (action.payload) {
        case "Internship":
          state.jobTypeFilter = filteredJobsType.filter(
            (job) => job.type === "Internship"
          );
          state.jobType = "Internship";
          break;
        case "Remote":
          state.jobTypeFilter = filteredJobsType.filter(
            (job) => job.type === "Remote"
          );
          state.jobType = "Remote";
          break;
        case "Full Time":
          state.jobTypeFilter = filteredJobsType.filter(
            (job) => job.type === "Full Time"
          );
          state.jobType = "Full Time";
          break;
        default:
          state.jobTypeFilter = [];
          state.jobType = "";
          break;
      }
    },
    filterByJobTypeInActive: (state) => {
      state.jobTypeFilter = [];
      state.jobType = "";
    },
    searchSortFilterJob: (state, action) => {
      const { searchValue, sort } = action.payload;
      let filteredJobs = state.jobs;
      if (searchValue !== "") {
        filteredJobs = filteredJobs.filter((job) =>
          job.title.toLowerCase().includes(searchValue.toLowerCase())
        );
      }
      if (sort !== "") {
        filteredJobs = [...filteredJobs].sort((a, b) =>
          sort === "LowToHigh" ? a.salary - b.salary : b.salary - a.salary
        );
      }
      if (state.jobType !== "") {
        filteredJobs = filteredJobs.filter(
          (job) => job.type.toLowerCase() === state.jobType.toLowerCase()
        );
      }
      state.sortSearchFilter = filteredJobs?.length > 0 ? filteredJobs : "";
    },
    searchSortInActive: (state) => {
      state.sortSearchFilter = [];
    },
    editActive: (state, action) => {
      state.editing = action.payload;
    },
    editInActive: (state) => {
      state.editing = {};
    },
  },
  extraReducers: (builder) => {
    builder
      //fetch Jobs
      .addCase(fetchJobs.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchJobs.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.jobs = action.payload;
      })
      .addCase(fetchJobs.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.jobs = [];
        state.error = action.error.message;
      })
      //Create Job
      .addCase(createJob.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(createJob.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.jobs.push(action.payload);
      })
      .addCase(createJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error.message;
      })
      // Edit Job
      .addCase(editJob.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(editJob.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        const indexToUpdate = state.jobs.findIndex(
          (job) => job.id === action.payload.id
        );
        state.jobs[indexToUpdate] = action.payload;
      })
      .addCase(editJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error.message;
      })
      // Remove Job
      .addCase(deleteJob.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(deleteJob.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.sortSearchFilter = [];
        state.jobs = state.jobs.filter((job) => job.id !== action.meta.arg);
      })
      .addCase(deleteJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error.message;
      });
  },
});

export default jobsFinderSlice.reducer;
export const {
  filterByJobType,
  filterByJobTypeInActive,
  searchSortFilterJob,
  searchSortInActive,
  editActive,
  editInActive,
} = jobsFinderSlice.actions;
